export const Color = {
  BRAND: '#FFCC00',
  HEADER_BG: '#202020',
  BODY_BG: '#FFFFEF',
  FOREGROUND: '#333333',
  LINK: '#0033FF',
} as const;
